import { H6, Image, P } from "../../../../../AbstractElements";
import { CURRENT_CART_DATA } from "../../../../../Data/FormLayout";
import { dynamicImage } from "../../../../../Service/DynamicImage";

const CurrentCartTableBody = () => {
  return (
    <tbody>
      {CURRENT_CART_DATA.map((data, index) => (
        <tr key={index}>
          <td>
            <Image src={dynamicImage(`${data.imagePath}`)} alt="t-shirt"/>
          </td>
          <td>
            <div >
              <H6>{data.productName}</H6>
              <span>{data.productSum}</span>
            </div>
          </td>
          <td>
            <P>{data.price}</P>
          </td>
        </tr>
      ))}
    </tbody>
  );
};

export default CurrentCartTableBody;
